<template>
    <div class="text-center">
        <v-dialog v-model="$store.state.loader" hide-overlay persistent width="300">
            <v-card color="green" dark>
                <v-card-text>
                    Fetching data...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    computed: {
        getThemeColor() {
            return this.$store.getters.getThemeColor;
        }
    }
};
</script>
